export enum IS32ConfigurationDeviceType {
  Unknown = 'Unknown',
  Universal = 'Universal',
  Sec0104 = 'SEC0104',
  Sec0105 = 'SEC0105',
  Sec0106 = 'SEC0106',
  S0303 = 'S0303',
  S0304 = 'S0304',
}
